// ============================================================
// Callback SSO cho đăng nhập của trang nhúng /embed/booking
//
// Iframe ẩn hoặc popup do trang nhúng mở → SSO redirect về CURRENT_HOST
// (gốc origin, cùng redirect_uri đã đăng ký cho AuthInit). State có tiền tố
// EMBED_STATE_PREFIX để phân biệt với luồng đăng nhập thường của AppShell:
// popup KHÔNG tự đổi code lấy token mà chuyển nguyên code/state về iframe
// (iframe giữ code_verifier PKCE trong bộ nhớ và tự đổi token).
//
// File này chạy TRƯỚC async boundary của Module Federation (index.tsx) nên
// tuyệt đối không import react/axios/… (shared eager:false → lỗi eager consumption).
// ============================================================

export const EMBED_STATE_PREFIX = 'embed.'
export const EMBED_SSO_MESSAGE_TYPE = 'xcare-embed-sso-callback'

/**
 * Nếu trang hiện tại là redirect SSO của popup nhúng → gửi kết quả về iframe
 * mở popup rồi đóng popup. Trả true khi đã xử lý (không bootstrap app).
 */
export function handleSsoPopupCallback(): boolean {
  const params = new URLSearchParams(window.location.search)
  const state = params.get('state')
  if (!state || !state.startsWith(EMBED_STATE_PREFIX)) return false

  const payload = {
    type: EMBED_SSO_MESSAGE_TYPE,
    state,
    code: params.get('code'),
    error: params.get('error_description') || params.get('error'),
  }

  // Popup → gửi cho opener; iframe ẩn (đăng nhập tự động) → gửi cho trang cha.
  // Cả hai đều là trang nhúng cùng origin → chỉ gửi cho đúng origin này.
  const opener = window.opener as Window | null
  if (opener && !opener.closed) {
    opener.postMessage(payload, window.location.origin)
    window.close()
  } else if (window.parent !== window) {
    window.parent.postMessage(payload, window.location.origin)
    return true
  }

  // Không còn opener (bị chặn/COOP) hoặc window.close() không có tác dụng
  document.body.innerHTML =
    '<div style="font-family:sans-serif;padding:24px;text-align:center">' +
    'Đăng nhập xong. Hãy đóng cửa sổ này và bấm "Đăng nhập HIS" lại trong omnichannel nếu form chưa mở.' +
    '</div>'
  return true
}
